import { Provider } from '@angular/core';
import {
  GetTeamNamesUseCase,
  GetUserManagementListUseCase,
  SyncUsersUseCase,
  UpdateUsersUseCase,
} from '@app/application/use-cases/user-management';
import { UserManagementRepository } from '@app/domain/repositories/user-management.repository';
import { UserManagementRepositoryImpl } from '../repositories/user-management.repository.impl';

export const USER_MANAGEMENT_PROVIDERS: Provider[] = [
  {
    provide: UserManagementRepository,
    useClass: UserManagementRepositoryImpl,
  },
  {
    provide: GetUserManagementListUseCase,
    useFactory: (userManagementRepo: UserManagementRepository) =>
      new GetUserManagementListUseCase(userManagementRepo),
    deps: [UserManagementRepository],
  },
  {
    provide: UpdateUsersUseCase,
    useFactory: (userManagementRepo: UserManagementRepository) =>
      new UpdateUsersUseCase(userManagementRepo),
    deps: [UserManagementRepository],
  },
  {
    provide: GetTeamNamesUseCase,
    useFactory: (userManagementRepo: UserManagementRepository) =>
      new GetTeamNamesUseCase(userManagementRepo),
    deps: [UserManagementRepository],
  },
  {
    provide: SyncUsersUseCase,
    useFactory: (userManagementRepo: UserManagementRepository) =>
      new SyncUsersUseCase(userManagementRepo),
    deps: [UserManagementRepository],
  },
];
